import React from 'react'
import cx from 'classnames'

import Box from './box'

import './ui.scss'

const Screen = ({
  className,
  children,
}) => {
  const classes = cx(className, 'm-screen')

  return (
    <Box className={classes}>
      {children}
    </Box>
  )
}

export default Screen
